import React,{useEffect} from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router'


const Navbar = () => {
    const location = useLocation();
    useEffect(() => {
  }, [location]);
  return (
    <div className="classnav">
      <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark ">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            iNotebook
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/" ? "active" :""}`} aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/about" ? "active" :""}`} aria-current="page" to="/about">
                  About us
                </Link>
              </li>
            </ul>
            <form className="d-flex" role="search">
          {!localStorage.getItem("token") && (
              <>
              <Link className="btn btn-outline-light mx-1" to="/login">
                Login
              </Link>
              <Link className="btn btn-outline-light mx-1" to="/signup">
                SignUp
              </Link>
            </>
          )}
          {localStorage.getItem("token") && (
            <Link className="btn btn-outline-light mx-1" to="/login" onClick={()=>{
              localStorage.removeItem("token")}}>
              Logout
            </Link>
          )}
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
